<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>部门模块</el-breadcrumb-item>
        <el-breadcrumb-item>新增部门</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">部门名称：</div>
          <el-input v-model="user.name"
                    style="width: unset;"
                    placeholder="请输入部门名称"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">负责人姓名：</div>
          <el-input v-model="user.contacts"
                    style="width: unset;"
                    placeholder="请输入员工名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">负责人电话：</span>
          <el-input v-model="user.tel"
                    class="inputRight"
                    maxlength="11"
                    style="width: unset;"
                    placeholder="请输入负责人电话"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">备注：</span>
          <el-input v-model="user.remark"
                    type="textarea"
                    class="inputRight"
                    style="width: 200px;"
                    placeholder="请输入备注"></el-input>
        </div>
        <div class="inputDiv">
          <el-button type="primary"
                     class="widthButton"
                     @click="add">确认</el-button>
          <el-button class="widthButton"
                     @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { deptAdd } from "@/api/department";
export default {
  data() {
    return {
      user: {
        name: "",
        contacts: "",
        tel: "",
        remark: ""
      }
    };
  },
  methods: {
    add() {
      const params = {
        tel: this.user.tel,
        name: this.user.name,
        enterpriseId: localStorage.getItem("company_id"),
        contacts: this.user.contacts,
        remark: this.user.remark
      };
      deptAdd(params)
        .then(res => {
          if (res.count == 1) {
            this.$message({
              message: "创建成功",
              type: "success"
            });
            this.$router.go(-1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
